import React from 'react'
import BodyText from 'components/Luxkit/Typography/BodyText'
import styled from 'styled-components'
import { verticalChildSpacing } from 'components/utils/spacing'
import TextLink from 'components/Luxkit/TextLink'
import Group from 'components/utils/Group'

const Stack = styled.div`
  ${verticalChildSpacing[20]}
`

interface Props {
  traderInformation: App.TraderInformation;
}

function TraderInformation(props: Props) {
  const { traderInformation } = props

  const body = []
  const businessRegister = []
  if (traderInformation.address) {
    const address = []
    if (traderInformation.address.line1) {
      body.push(traderInformation.address.line1)
    }
    if (traderInformation.address.line2) {
      body.push(traderInformation.address.line2)
    }
    if (traderInformation.address.line3) {
      body.push(traderInformation.address.line3)
    }
    if (traderInformation.address.city) {
      address.push(traderInformation.address.city)
    }
    if (traderInformation.address.stateProvinceCode) {
      address.push(traderInformation.address.stateProvinceCode)
    }
    if (traderInformation.address.postalCode) {
      address.push(traderInformation.address.postalCode)
    }
    if (traderInformation.address.countryCode) {
      address.push(traderInformation.address.countryCode)
    }
    if (address.length > 0) {
      body.push(address.join(' '))
    }
    if (traderInformation.email) {
      body.push(traderInformation.email)
    }
    if (traderInformation.phone) {
      body.push(traderInformation.phone)
    }
  }

  if (traderInformation.businessRegisterName || traderInformation.businessRegisterNumber) {
    if (traderInformation.businessRegisterName) {
      businessRegister.push(traderInformation.businessRegisterName)
    }
    if (traderInformation.businessRegisterNumber) {
      businessRegister.push(traderInformation.businessRegisterNumber)
    }
  }

  return (
    <Stack>
      <Group gap={12} direction="vertical">
        {(body.length > 0 || traderInformation.name) && (<div>
          {traderInformation.name && <BodyText variant="medium" weight="bold">{traderInformation.name}</BodyText>}
          {body.map((info, index) => <BodyText key={index} variant="medium">{info}</BodyText>)}
          {businessRegister.map((info, index) => <BodyText key={index} variant="medium" weight="bold">{info}</BodyText>)}
        </div>)}
        <BodyText variant="medium">This property is managed by a professional host. The provision of housing is linked to trade, business or profession</BodyText>
        {traderInformation.termsAndConditions &&
          <TextLink weight="regular" href={traderInformation.termsAndConditions} target="_blank">
            Terms & conditions
          </TextLink>
        }
      </Group>
    </Stack>
  )
}

export default React.memo(TraderInformation)
